import React, { FunctionComponent, ReactNode } from 'react';
import { Button as IBIButton } from './styles';
import { getActiveStyle, getHoverStyle, getStyle, size as sizeType, defaultStyle } from './helpers';
import { variant as variantType } from './buttonVariants';
import _ from 'lodash';
import { VHFlexCenterClassnames } from '../../commonClassNames';
import IBILoader from '../../UIComponents/IBILoader';

export interface ButtonProps {
    children: ReactNode;
    loading?: boolean;
    size?: sizeType;
    variant?: variantType;
    disabled?: boolean;
    onClick?: (...args: unknown[]) => unknown;
    title?: string | null;
    className?: string;
    onKeyPress?: any;
    id?: string;
    type?: any;
    value?: any;
    style?: any;
    tooltip?: any;
    tabIndex?: number;
}

const Button: FunctionComponent<ButtonProps> = ({
    children,
    disabled = false,
    loading = false,
    size = 'lg',
    title = '',
    variant = 'primary',
    className = '',
    type = 'button',
    style,
    tabIndex,
    onClick
}: ButtonProps) => {
    /*
     *  We need this as typescript currently doesn't support default props so we need to check
     *  if variant,size are being passed or else typescript marks them undefined
     *  even if default props are passed
     */
    const defaultHoverStyle = {
        backgroundColor: '#FFFFFF',
        color: '#000000',
        border: 'red'
    };

    const defaulActiveStyle = {
        backgroundColor: '#FFFFFF',
        color: '#000000',
        border: 'red'
    };

    // This is the default style when button is rendered on dom
    const generalStyle = variant
        ? _.merge({}, getStyle(variant, size, disabled), style)
        : _.merge({}, defaultStyle, style);

    // Hover Style of button
    const hoverStyle = variant
        ? _.merge({}, getHoverStyle(variant), style)
        : _.merge({}, defaultHoverStyle, style);

    const activeStyle = variant
        ? _.merge({}, getActiveStyle(variant), style)
        : _.merge({}, defaulActiveStyle, style);
    return (
        <IBIButton
            as='button'
            className={className}
            tabIndex={tabIndex}
            disabled={disabled || false}
            generalStyle={generalStyle}
            hoverStyle={hoverStyle}
            activeStyle={activeStyle}
            title={title || ''}
            type={type}
            onClick={onClick}
        >
            <b className={`${VHFlexCenterClassnames} text-truncate`}>
                {loading ? <IBILoader width={20} height={20} /> : children}
            </b>
        </IBIButton>
    );
};

export default Button;
